/*
 * Hook: 获取 Kubernetes 集群信息
 */

import { useEntity } from '@backstage/plugin-catalog-react';
import { KUBERNETES_ANNOTATIONS, ClusterInfo } from '../types';

/**
 * 从 Entity 注解中获取 Kubernetes 集群信息
 * 支持识别 powered-by 类型（knative/argocd/kubernetes）
 */
export function useKubernetesClusterInfo(): ClusterInfo {
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations || {};
  
  const clusterName = annotations[KUBERNETES_ANNOTATIONS.CLUSTER_NAME] || '';
  const namespace = annotations[KUBERNETES_ANNOTATIONS.NAMESPACE] || 
                    annotations[KUBERNETES_ANNOTATIONS.KNATIVE_SERVICE_NAMESPACE] || 
                    'default';
  const kubernetesId = annotations[KUBERNETES_ANNOTATIONS.ID] || entity.metadata.name;
  
  // 获取 powered-by 类型
  const poweredByRaw = annotations[KUBERNETES_ANNOTATIONS.POWERED_BY] || '';
  let poweredBy: ClusterInfo['poweredBy'] = 'kubernetes';
  if (poweredByRaw === 'knative') {
    poweredBy = 'knative';
  } else if (poweredByRaw === 'argocd' || annotations['argocd/app-name']) {
    poweredBy = 'argocd';
  }
  
  // Knative 服务名称
  const knativeServiceName = annotations[KUBERNETES_ANNOTATIONS.KNATIVE_SERVICE_NAME];
  
  return {
    name: clusterName,
    namespace,
    workloadName: kubernetesId,
    kubernetesId,
    poweredBy,
    knativeServiceName,
  };
}

